import { render } from "./LostConnection.vue?vue&type=template&id=a1f0c930"
import script from "./LostConnection.vue?vue&type=script&lang=js"
export * from "./LostConnection.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\Desarrollo\\Documents\\Inventarios 2.0\\Technosoft.Inventarios.v2\\Technosoft.Inventarios.v2.UI.Web\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__